export default __webpack_public_path__ + "static/media/Preschool.1bdad231.png";